import { render, staticRenderFns } from "./visit-settle-case-manage.vue?vue&type=template&id=61de99a4&scoped=true"
import script from "./visit-settle-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-settle-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de99a4",
  null
  
)

export default component.exports